var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"mt-5 flex-1 px-3 space-y-2"},_vm._l((_vm.nav),function(item,idx){return _c('div',{key:`navItem-${idx}`},[_c('app-nav-item',{attrs:{"item":item,"idx":idx}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }